import {
  CreateDerivativesOrderRequest,
  DerivativesOrderProjection,
  DerivativesOrderSide,
} from 'common/api/autogenerated/trading-gateway';

export enum ActiveFields {
  QUONTITY = 'quantity',
  TOTAL = 'total',
}

// 85523 TEMP CODE TO SHOW TEMPORARY UNAVAILABLE ERROR
export enum DerivativesPriceType {
  LAST = 'Last',
  MARK = 'Mark',
}

export interface DerivativeOrderFormType
  extends Pick<
    DerivativesOrderProjection,
    | 'quantity'
    | 'leverage'
    | 'condition'
    | 'positionMode'
    | 'marginMode'
    | 'reduceOnly'
    | 'type'
    | 'tradingPairCode'
    | 'source'
  > {
  mode: DerivativeOrderFormMode;
  action: DerivativesOrderSide;
  balance: number;
  base: string;
  quoted: string;
  tpsl: boolean;
  total: number | undefined;
  takeProfit: number | undefined;
  stopLoss: number | undefined;
  triggerPrice: number | undefined;
  targetPrice: number | undefined;
  bestAsk: number | undefined;
  bestBid: number | undefined;
  limitPrice: number | undefined;
  activeField: ActiveFields;
  useBestPrice: boolean;
  allowSaveConfiguration: boolean;
  percentage: string | null;
  triggerPriceType: DerivativesPriceType;
  limitPriceType: DerivativesPriceType;
  takeProfitTriggerPriceType: DerivativesPriceType;
  stopLossTriggerPriceType: DerivativesPriceType;
  liquidity: boolean;
  takerFeeRate: number;
  isDirtyFromProps: boolean;
}

export type DerivativeOrderFormMode = 'create' | 'edit' | 'delete';

export interface IDerivativeOrderForm extends Partial<DerivativeOrderFormType> {
  editLimitPrice?: number | null;
  editTriggerPrice?: number | null;
  editQuantity?: number | null;
  mode?: DerivativeOrderFormMode;
  update?: Partial<DerivativeOrderFormType>;
  onSubmit?: (data: CreateDerivativesOrderRequest) => Promise<void>;
  onDelete?: () => Promise<void>;
}

export interface MarketProps {
  base: string;
  quoted: string;
  digitsForQuantity: number;
  digitsForTotal: number;
}

export interface LimitProps extends MarketProps {
  limitPrice: number | undefined;
}

export interface StopMarketProps extends MarketProps {
  action: DerivativesOrderSide | undefined;
  triggerPrice: number | undefined;
}

export interface StopLimitProps extends MarketProps {
  action: DerivativesOrderSide | undefined;
  limitPrice: number | undefined;
  triggerPrice: number | undefined;
  limitPriceType: DerivativesPriceType | undefined;
}
